/**
 * Factory for the editor save Web Worker.
 * Isolated so that `import.meta.url` lives in one small file
 * that Jest can mock, while the hook logic remains fully testable.
 */
export function createSaveWorker(): Worker {
  try {
    const worker = new Worker(new URL('./editorSaveWorker.ts', import.meta.url), {
      type: 'module',
    });
    console.debug('[createSaveWorker] Worker created successfully', {
      url: new URL('./editorSaveWorker.ts', import.meta.url).href,
    });
    return worker;
  } catch (err) {
    console.error('[createSaveWorker] Failed to instantiate Web Worker', err);
    throw err;
  }
}
